<script lang="ts">
const __DsBlock = {
	hidden: true,
	category: 'file-preview',
	tags: ['video/'],
	events: [
		{
			name: 'remove',
			payload: [],
		},
	],
}
</script>
<script lang="ts" setup>
import type { FilePreviewBlockEmits, FilePreviewBlockProps } from '#layers/assets/types/file-preview';
import { useProjectAssetURL } from '#imports';
import { defineBlock } from '#layers/block-engine';

const { file, showRemove = true } = defineProps<FilePreviewBlockProps>();
defineEmits<FilePreviewBlockEmits>();

;

const assetURL = useProjectAssetURL(() => file);
</script>

<template>
	<div class="overflow-hidden rounded-lg border">
		<MediaControls download :src="assetURL" class="group relative">
			<FileInfoActionOverlay
				direction="top"
				:file
				:show-remove
				:download="false"
				:ui="{
					gradient: `
						not-group-[[mediapaused]]:h-10! not-group-[[mediapaused]]:from-neutral-800/25!
						group-[[mediaisfullscreen]]:h-10! group-[[mediaisfullscreen]]:from-neutral-800/25!
					`,
					additionalInfo: 'not-group-[[mediapaused]]:max-h-0! group-[[mediaisfullscreen]]:max-h-0!',
					actionOverlay: 'not-group-[[mediapaused]]:opacity-0! group-[[mediaisfullscreen]]:opacity-0!',
				}"
				@remove="$emit('remove')"
			/>

			<template #media="mediaProps">
				<video playsinline preload="metadata" :src="assetURL" v-bind="mediaProps" />
			</template>
		</MediaControls>
	</div>
</template>
